import abi from "./contract.json"

export const bytecode = abi.bytecode;